import React from 'react';
import { TextField, Box } from '@mui/material';
import { FormikValues } from 'formik';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import BrandButton from '../../components/BrandButton/BrandButton';
import { LocalizePropType } from 'getaway-data-layer';
import { GA_TITLES } from '../../../utils';
import './ForgetPasswordView.less';

type props = {
  localize: LocalizePropType;
  formik: FormikValues;
  onClose: () => void;
  onPressForgotEmail: () => void;
};

const ForgotPasswordView = ({
  localize,
  formik,
  onClose,
  onPressForgotEmail,
}: props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="ForgotPasswordView-title"
        DescriptionTestId="ForgotPasswordView-description"
        title={localize('login.forgot.title')}
        description={localize('login.forgot.desc')}
        showHelp
        onClose={onClose}
        showArrowBack
      />
      <div className="screen-body">
        <Box component="form" noValidate onSubmit={formik.handleSubmit}>
          <TextField
            data-testid="ForgotPasswordView-emailInput"
            required
            fullWidth
            id="email"
            className="form-input"
            label={localize('login.email.placeholder')}
            helperText={(formik.touched.email && formik.errors.email) || ''}
            error={formik.touched.email && Boolean(formik.errors.email)}
            variant="standard"
            type="email"
            autoComplete="email"
            {...formik.getFieldProps('email')}
          />
          <div
            onClick={onPressForgotEmail}
            className="forget-password-forget-email-container"
          >
            <div
              data-testid="ForgotPasswordView-forgotEmailBtn"
              className="forget-password-forget-email-text"
            >
              {localize('forget.email')}
            </div>
          </div>
          <BrandButton
            id={GA_TITLES.AUTH.FORGOT}
            title={localize('login.forgot.text')}
            formik={formik}
          />
        </Box>
      </div>
    </div>
  );
};

export default ForgotPasswordView;
